"use strict";

var moduleName = "catalog-compare";

module.exports = function () {
	$(".jsCompare").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);



		// Добавляем body класс pop-up-fixed, чтобы корректно работал pop-up. YAC.
		$('body').addClass('pop-up-fixed');



		//
		// Переключатель
		//

		$(".jsCompareToggle").on("click", function(e) {
			e.preventDefault();

			$(this).removeClass("active").siblings().removeClass("active");
			$(this).addClass("active");
		});



		//
		// Удаление товара
		//

		$(".jsCompareDelete").on("click", function(e) {
			e.preventDefault();

			// Порядковый номер продукта (Начинается с 0)
			var numberProduct = $(this).closest(".jsCompareProduct").index() + 1;
//			alert(numberProduct);

			// Удаляем продукт
			$(this).closest(".jsCompareProduct").remove();

			// Удаляем ячейки в таблице
			$(".jsCompareTable tr").each(function() {
				var wrap = $(this);

				wrap.find("td").eq(numberProduct).remove();
			});
		});



		//
		// Отлавливаем переключение и сравниваем
		//

		$(".jsCompareToggle").on("click", function(e) {
			e.preventDefault();

			if($(this).hasClass("jsCompareToggleDiffering")) {

				$("table tr").each(function() {
					var wrap            = $(this),
						allCell         = wrap.find("td:not(:nth-of-type(1))"),
						textFirstCell   = wrap.find("td:nth-of-type(2)").text(),
						allValueTheSame = true;

					allCell.each(function() {
						var textCell = $(this).text();

						if (textCell == textFirstCell) {
							textFirstCell = textCell;
						} else {
							allValueTheSame = false;
							return false;
						}
					});


					if (allValueTheSame) {
						wrap.hide();
					}
				});
			} else {
				$(".jsCompareTable tr").show();
			}

			
			
			$(".jsCompareTable tr").css("background", "transparent");
			$(".jsCompareTable tr:visible").each(function(index) {
				if ( (index - 1) % 2 == 0 ) {
					$(this).css("background", "#fff");
				}
				
				
			});
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/compareInit.js
 **/